/**
 * These materials are used to render material ids.
 */
import type { MaterialSrc } from "common/materials/materialSrc";
import { hashInts3 } from "geom/utils";
import * as THREE from "three";

export const noIdMaterial = new THREE.MeshBasicMaterial({
  color: new THREE.Color(0, 0, 0),
  fog: false,
  name: "idMaterial noIdMaterial",
});

const idMaterialCache: { [id: number]: THREE.Material } = {};

/**
 * This supports up to 2^24 materials.
 * @param id Integer id of the material
 * @returns material
 */
export function getIdMaterial(id: number): THREE.Material {
  if (idMaterialCache.hasOwnProperty(id)) {
    return idMaterialCache[id];
  }
  const idColorR = (id & 0xff) / 255;
  const idColorG = ((id >> 8) & 0xff) / 255;
  const idColorB = ((id >> 16) & 0xff) / 255;
  const material = new THREE.MeshBasicMaterial({
    color: new THREE.Color(idColorR, idColorG, idColorB),
    fog: false,

    // This material is double-sided to support section view rendering.
    // In case solid meshes are cut in the middle by the section view clipping plane, we want the backfaces visible.
    side: THREE.DoubleSide,
    name: "idMaterial material",
  });
  idMaterialCache[id] = material;
  return material;
}

export function materialSrcToIdMaterial(materialSrc: MaterialSrc | undefined): THREE.Material {
  if (!materialSrc) {
    return noIdMaterial;
  }
  const materialSrcHash = hashInts3(
    materialSrc.templateId,
    materialSrc.layerConfigId !== undefined ? materialSrc.layerConfigId + 1 : 0,
    materialSrc.colorId !== undefined ? materialSrc.colorId + 1 : 0,
  );
  return getIdMaterial(materialSrcHash);
}
